export const strings = {
  CARRIER_FR: {
    FUEL_ADVANCE_UNAVAILABLE: "This Debtor is Not Approved for Fuel Advances",
    FUEL_ADVANCE_NOA_NOT_PLACED:
      "Fuel Advances are not available for this Debtor until your NOA is Placed (Active) ",
    ADD_DEBTOR_TO_FUEL_ADVANCE: "Please Add Debtor to Request a Fuel Advance",
    ALREADY_TAKE_ADVANCE_FROM_CUSTOMER:
      "Did you already take an advance from your customer on this load? If you did please enter the amount of this advance below.",
    INCLUDE_DETAIL_TO_FR: "You can include more details for this payment request below."
  }
};
